import Image from 'next/image';
import { FaTwitter, FaGithub } from 'react-icons/fa';
import countries from 'i18n-iso-countries';
import ReactCountryFlag from 'react-country-flag';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default function ShowcaseCard({ author, description }) {
  const { name, country, twitterHandle, github, photo } = author;

  const upperCountryCode = country.toUpperCase();
  const countryName = countries.getName(upperCountryCode, 'en', {
    select: 'alias',
  });

  return (
    <div className="flex justify-between flex-col">
      <div className="relative">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute -top-3 -left-3 z-0"
        >
          <path
            d="M3.66334 25.0275C1.9304 23.1869 1 21.1225 1 17.7761C1 11.8875 5.13381 6.60962 11.1453 4.00012L12.6477 6.31856C7.03668 9.35372 5.93971 13.2924 5.50227 15.7757C6.40575 15.308 7.58853 15.1448 8.74774 15.2524C11.7829 15.5334 14.1754 18.0251 14.1754 21.1225C14.1754 22.6843 13.555 24.1821 12.4506 25.2864C11.3463 26.3908 9.84851 27.0112 8.28675 27.0112C6.48146 27.0112 4.75526 26.1868 3.66334 25.0275ZM20.488 25.0275C18.755 23.1869 17.8246 21.1225 17.8246 17.7761C17.8246 11.8875 21.9584 6.60962 27.9699 4.00012L29.4723 6.31856C23.8613 9.35372 22.7643 13.2924 22.3269 15.7757C23.2304 15.308 24.4132 15.1448 25.5724 15.2524C28.6075 15.5334 31 18.0251 31 21.1225C31 22.6843 30.3796 24.1821 29.2753 25.2864C28.1709 26.3908 26.6731 27.0112 25.1114 27.0112C23.3061 27.0112 21.5799 26.1868 20.488 25.0275Z"
            fill="#17245E"
          />
        </svg>

        <p className="text-base md:text-lg leading-7 relative z-10">
          {description}
        </p>
      </div>

      <div className="flex items-center justify-between mt-6">
        <div className="flex items-center">
          <Image
            width={40}
            height={40}
            src={photo}
            alt={`${name} photo`}
            className="rounded-full object-contain"
          />

          <div className="text-sm leading-5 ml-3">
            <p className="text-white font-medium">{name}</p>
            <p className="text-rock-blue flex items-center">
              <ReactCountryFlag
                className="w-4 leading-3 mr-1"
                svg
                countryCode={upperCountryCode}
                aria-label={`${countryName} flag`}
              />

              {countryName}
            </p>
          </div>
        </div>

        {(twitterHandle || github) && (
          <div className="flex items-center space-x-3 text-rock-blue">
            {github && (
              <a
                href={github}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                <FaGithub className="w-5 h-5" />
              </a>
            )}
            {twitterHandle && (
              <a
                href={`https://twitter.com/${twitterHandle}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                <FaTwitter className="w-5 h-5" />
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
